import { render, staticRenderFns } from "./BackgroundDashboard.vue?vue&type=template&id=bdec0dc2"
import script from "./BackgroundDashboard.vue?vue&type=script&lang=js"
export * from "./BackgroundDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports